import React, { useState, useRef } from 'react';
import { Anchor, Box, Text, Drop } from 'wt-ui';
import { Trans } from 'react-i18next';
import { CircleQuestion } from 'grommet-icons';

import i18next from '../../translations/i18n';

const Help = () => {
  const [over, setOver] = useState(false);
  const ref = useRef(null);

  return (
    <Anchor forwardRef={ref} onClick={() => setOver(!over)}>
      <CircleQuestion size="medium" />
      {ref.current && over && (
        <Drop align={{ top: 'bottom', right: 'right' }} target={ref.current} plain>
          <Box pad="small" background="#ffffff" width="350px" border={{ color: '#333' }}>
            <Text size="medium">{i18next.t('Disclaimer')}</Text>
          </Box>
        </Drop>
      )}
    </Anchor>
  );
};

const HeatMapScale = () => (
  <Box background="transparent" align="end">
    <Box background="transparent">
      <Box background="transparent" direction="row">
        <Help />
        <div
          style={{
            marginLeft: '10px',
            display: 'table',
            width: '160px',
            height: '10px',
            background: 'linear-gradient(90deg, #84bd00, #5b6770, #e63a44)',
          }}
        />
      </Box>

      <Box background="transparent" justify="between" direction="row" style={{ paddingLeft: '35px' }}>
        <Text color="#84bd00">
          <Trans>Positive</Trans>
        </Text>
        <Text>
          <Trans>%</Trans>
        </Text>
        <Text alignSelf="end" color="#e63a44">
          <Trans>Negative</Trans>
        </Text>
      </Box>
    </Box>
  </Box>
);

export default HeatMapScale;
